const en = {
  // Navbar
  nav_home: 'Home',
  nav_trader: 'VPS Trader',
  nav_trader_all: 'View all plans',
  nav_trader_br: 'VPS Trader BR',
  nav_trader_uk: 'VPS Trader UK',
  nav_trader_us: 'VPS Trader US',
  nav_dev: 'VPS Devs',
  nav_dev_all: 'VPS for Developers',
  nav_personal: 'Personal VPS',
  nav_personal_all: 'VPS for Personal Use',
  nav_corporate: 'Enterprise VPS',
  nav_enterprise: 'Enterprise VPS',
  nav_company: 'Company',
  nav_about: 'About Us',
  nav_datacenter: 'Data Center',
  nav_contact: 'Contact',
  nav_client_area: 'Client Area',
  nav_hire: 'Get Started',
  // Plans table
  plans_processor: 'Processor',
  plans_cores: 'Cores/Threads',
  plans_memory: 'Memory',
  plans_disk: 'Disk',
  plans_traffic: 'Traffic',
  plans_value: 'Price',
  plans_hire: 'Order Now',
  plans_popular: 'Popular',
  plans_unlimited: 'Unlimited',
  plans_footer_note: '* All plans include free setup, 24/7 support in PT-BR & EN, Anti-DDoS protection. Prices in BRL including taxes.',
  // Footer
  footer_about: 'VPS specialists since 2008. High-performance infrastructure for traders, developers and businesses in Brazil and worldwide.',
  footer_trader: 'VPS Trader',
  footer_solutions: 'Solutions',
  footer_company: 'Company',
  footer_rights: 'All rights reserved.',
  footer_systems: 'All systems operational',
  // Common
  btn_specialist: 'Talk to a Specialist',
  btn_doubt: 'Have questions?',
  choose_location: 'See also:',
  datacenter_label: 'Datacenter',
  latency_label: 'Average latency',
  exchange_label: 'Exchanges / Brokers',
};

export default en;
